import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/one-vigilance/pharmacovigilance-certified-blended-training")({
  head: () => buildRouteHead("/en/services/one-vigilance/pharmacovigilance-certified-blended-training", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/services/pharmacovigilance/pharmacovigilance-certified-blended-training", replace: true });
  },
});
